// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchPage_wrapper__u+Zff","background":"SearchPage_background__6heyO","background-overlay":"SearchPage_background-overlay__7Tz8J"};